<template>
  <v-item-group
    v-model="form.values.visitTime"
    class="hour-container"
    @change="checkFormValidation"
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        v-for="(interval,index) in visitHours"
        :key="index"
        md4
        xs12
      >
        <v-subheader class="interval-name">
          {{ getIntervalTitle(index) }}
        </v-subheader>
        <div
          v-if="interval.length === 0"
          class="grey--text"
        >
          {{ $t('appointment.noAppointments') }}
        </div>
        <v-item
          v-for="(hour, hourIndex) in interval"
          :key="`${date}-${index}-${hourIndex}`"
          :value="hour.format('HH:mm')"
        >
          <v-chip
            slot-scope="{ active, toggle }"
            outline
            color="secondary"
            :selected="active"
            @click="hour.format('HH:mm') !== form.values.visitTime && toggle()"
          >
            {{ hour.format('HH:mm') }}
          </v-chip>
        </v-item>
      </v-flex>
    </v-layout>
  </v-item-group>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { VISIT_TYPE_LIST_KEY } from '../../../store/types/appointment.types'

export default {
  name: 'AppointmentHours',
  props: {
    data: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    visitType: {
      type: Number,
      default: null,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visitDuration() {
      const selectedVisitType = this.visitTypeList.find(visitType => visitType.id === this.visitType)
      return typeof selectedVisitType !== 'undefined' ? selectedVisitType.defaultDuration : 0
    },
    visitHours() {
      let result = []
      this.data.forEach((timeRange) => {
        result = result.concat(this.mapTimeRangeToHoursArray(timeRange))
      })
      if (!moment(this.date).isSameOrAfter(moment())) {
        result = this.removeHoursBeforeCurrentHour(result)
      }
      result = this.removeDuplicateHours(result)
      return this.getHourIntervals(result)
    },
    ...mapState({
      visitTypeList: state => state.appointment[VISIT_TYPE_LIST_KEY],
    }),
  },
  methods: {
    mapTimeRangeToHoursArray(timeRange) {
      const hours = []
      const startHour = this.getStartHour(timeRange[0])
      const lastHour = this.getLastHour(timeRange[1])
      while (startHour <= lastHour) {
        hours.push(moment(startHour))
        startHour.add(15, 'minutes')
      }
      return hours
    },
    removeHoursBeforeCurrentHour(hours) {
      const now = moment()
      return this.isToday()
        ? hours.filter(
          hour => moment(hour.format('HH:mm'), 'HH:mm').isAfter(now),
        )
        : []
    },
    removeDuplicateHours(hours) {
      return hours.filter(
        (hour, index) => hours.findIndex(candidate => hour.isSame(candidate)) === index,
      ).sort(
        (a, b) => a - b,
      )
    },
    getHourIntervals(hours) {
      const intervals = [[], [], []]
      hours.forEach((hour) => {
        if (moment(hour.format('HH:mm'), 'HH:mm').isBefore(moment('12:00', 'HH:mm'))) intervals[0].push(hour)
        else if (moment(hour.format('HH:mm'), 'HH:mm').isBefore(moment('16:00', 'HH:mm'))) intervals[1].push(hour)
        else intervals[2].push(hour)
      })
      return intervals
    },
    getStartHour(time) {
      const roundUp = Math.ceil(moment(time).minute() / 15) * 15
      return moment(time).minute(roundUp)
    },
    getLastHour(time) {
      return this.visitType
        ? moment(time).subtract(this.visitDuration, 'minutes')
        : moment(time)
    },
    getIntervalTitle(index) {
      if (index === 0) return this.$t('appointment.afterTwelve')
      if (index === 1) return this.$t('appointment.beforeSixteenth')
      return this.$t('appointment.afterSixteenth')
    },
    isToday() {
      return this.date === moment().format('YYYY-MM-DD')
    },
    checkFormValidation(value) {
      this.$emit('isFormValid', value)
    },
  },
}
</script>

<style scoped>
  .hour-container {
    width: 100%;
  }
  .interval-name {
    justify-content: center;
  }
</style>
